/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import {FormControl, FormGroup} from "@angular/forms";
import { customRequiredValidation } from '@irian-ro/shared-components-module';

export class ServiceDTO extends JSONable {
  uuid: string | undefined = undefined;
  version: number | undefined = undefined;
  serviceTypeValue: string | undefined = undefined;
  trafficChannelTypeValue: string | undefined = undefined;
  volumeUnitValue: string | undefined = undefined;
  weightUnitValue: string | undefined = undefined;
  shipmentType: string | undefined = undefined;
  incotermValue: string | undefined = undefined;
  origin: string | undefined = undefined;
  destination: string | undefined = undefined;
  destinationAddresses: Array<any> | undefined = undefined;
  originAddresses: Array<any> | undefined = undefined;
  weightPerShipment: number | undefined = undefined;
  volumePerShipment: number | undefined = undefined;
  revenuePerShipment: number | undefined = undefined;
  grossProfitPerShipment: number | undefined = undefined;
  shipmentsPerYear: number | undefined = undefined;
  transitTime: number | undefined = undefined;
  comments: string | undefined = undefined;
  tags: Array<string> | undefined = undefined;
  currencyCode: string | undefined = undefined;

  static createForm(){
    return new FormGroup({
      uuid: new FormControl(null),
      version: new FormControl(null),
      serviceTypeValue: new FormControl(null, customRequiredValidation('serviceTypeValue')),
      trafficChannelTypeValue: new FormControl(null),
      volumeUnitValue: new FormControl(null),
      weightUnitValue: new FormControl(null),
      shipmentType: new FormControl(null),
      incotermValue: new FormControl(null),
      origin: new FormControl(null),
      destination: new FormControl(null),
      originAddresses: new FormControl([]),
      destinationAddresses: new FormControl([]),
      weightPerShipment: new FormControl(null),
      volumePerShipment: new FormControl(null),
      revenuePerShipment: new FormControl(null),
      grossProfitPerShipment: new FormControl(null),
      shipmentsPerYear: new FormControl(null),
      transitTime: new FormControl(null),
      comments: new FormControl(null),
      tags: new FormControl(null),
      currencyCode: new FormControl('EUR'),
    });
  }
}
